if (!customElements.get("wb-header-search")) {
    class WBHeaderSearch extends HTMLElement {
        constructor()
        {
            super();
            this.input = null;
            this.resultsContainer = null;
            this.debounceTimeout = null;
        }
        connectedCallback() {
            this.input = this.querySelector('input[type="search"]');
            this.resultWrapper = this.querySelector('.search-result');
            
            this.productListEl = this.querySelector('.product-search-list');
            this.footerEl   = this.querySelector('.search-footer');

            if (this.input) {
                this.input.addEventListener('input', this.handleInput.bind(this));
            }
        }
        handleInput(event) {
            const query = event.target.value.trim();
            var requestResponse;
            clearTimeout(this.debounceTimeout);

            this.debounceTimeout = setTimeout(() => {
                if (query.length < 2) {
                    this.productListEl.innerHTML = '';
                    this.noResultEl.classList.remove('hidden');
                    this.productListEl.classList.add('hidden');
                    return;
                }

                fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&section_id=predictive-search`)
                .then((response) => {
                    requestResponse = response;
                    return response.text();
                })
                .then(text => {
                    if (!requestResponse.ok) {
                        throw new Error(`${requestResponse.status}: ${text}`);
                    }

                    

                    const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-predictive-search #search-products').innerHTML;
                    
                    this.resultWrapper.innerHTML = resultsMarkup;
                    const readMoreMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-predictive-search #search-more').innerHTML;
                    this.footerEl.innerHTML = readMoreMarkup;
                    // this.productListEl.innerHTML = products.map(p => `
                    // <div class="item">
                    //     <div class="thumbnail">
                    //     <a href="${p.url}">
                    //         <img src="${p.image}" alt="${p.title}" loading="lazy" />
                    //     </a>
                    //     </div>
                    //     <div class="info">
                    //     <a href="${p.url}">${p.title}</a>
                    //     <span class="price-wrap">${this.formatPrice(p.price)}</span>
                    //     </div>
                    // </div>
                    // `).join('');
                })
                .catch(err => {
                    console.error('Search error:', err);
                    this.productListEl.innerHTML = '';
                    this.noResultEl.classList.remove('hidden');
                });
            }, 300);
        }
        formatPrice(priceInCents) {
            // Nếu Shopify.formatMoney tồn tại
            
            return pipelineVendor.themeCurrency.formatMoney(priceInCents);

        }


    }
    customElements.define("wb-header-search", WBHeaderSearch);
}